import { ecoLibs } from "../page-copy";

function logoSrc(logo: string) {
  return logo.includes(".") ? `/lib-logos/${logo}` : `/lib-logos/${logo}.svg`;
}

/** Compact library wall — logos from svgl.app. Static chips (no keyed-list). */
export default function EcosystemFigure() {
  return (
    <div className="eco-wall story-figure" aria-hidden="true">
      <ul className="eco-chips">
        <li className="eco-chip" style={{ ["--i" as any]: 0 }}>
          <img className="eco-chip-logo" src={logoSrc(ecoLibs[0].logo)} alt="" width={16} height={16} />
          <span className="eco-chip-name">{ecoLibs[0].name}</span>
        </li>
        <li className="eco-chip" style={{ ["--i" as any]: 1 }}>
          <img className="eco-chip-logo" src={logoSrc(ecoLibs[1].logo)} alt="" width={16} height={16} />
          <span className="eco-chip-name">{ecoLibs[1].name}</span>
        </li>
        <li className="eco-chip" style={{ ["--i" as any]: 2 }}>
          <img className="eco-chip-logo" src={logoSrc(ecoLibs[2].logo)} alt="" width={16} height={16} />
          <span className="eco-chip-name">{ecoLibs[2].name}</span>
        </li>
        <li className="eco-chip" style={{ ["--i" as any]: 3 }}>
          <img className="eco-chip-logo" src={logoSrc(ecoLibs[3].logo)} alt="" width={16} height={16} />
          <span className="eco-chip-name">{ecoLibs[3].name}</span>
        </li>
        <li className="eco-chip" style={{ ["--i" as any]: 4 }}>
          <img className="eco-chip-logo" src={logoSrc(ecoLibs[4].logo)} alt="" width={16} height={16} />
          <span className="eco-chip-name">{ecoLibs[4].name}</span>
        </li>
        <li className="eco-chip" style={{ ["--i" as any]: 5 }}>
          <img className="eco-chip-logo" src={logoSrc(ecoLibs[5].logo)} alt="" width={16} height={16} />
          <span className="eco-chip-name">{ecoLibs[5].name}</span>
        </li>
        <li className="eco-chip" style={{ ["--i" as any]: 6 }}>
          <img className="eco-chip-logo" src={logoSrc(ecoLibs[6].logo)} alt="" width={16} height={16} />
          <span className="eco-chip-name">{ecoLibs[6].name}</span>
        </li>
        <li className="eco-chip" style={{ ["--i" as any]: 7 }}>
          <img className="eco-chip-logo" src={logoSrc(ecoLibs[7].logo)} alt="" width={16} height={16} />
          <span className="eco-chip-name">{ecoLibs[7].name}</span>
        </li>
        <li className="eco-chip" style={{ ["--i" as any]: 8 }}>
          <img className="eco-chip-logo" src={logoSrc(ecoLibs[8].logo)} alt="" width={16} height={16} />
          <span className="eco-chip-name">{ecoLibs[8].name}</span>
        </li>
        <li className="eco-chip" style={{ ["--i" as any]: 9 }}>
          <img className="eco-chip-logo" src={logoSrc(ecoLibs[9].logo)} alt="" width={16} height={16} />
          <span className="eco-chip-name">{ecoLibs[9].name}</span>
        </li>
        <li className="eco-chip" style={{ ["--i" as any]: 10 }}>
          <img className="eco-chip-logo" src={logoSrc(ecoLibs[10].logo)} alt="" width={16} height={16} />
          <span className="eco-chip-name">{ecoLibs[10].name}</span>
        </li>
        <li className="eco-chip" style={{ ["--i" as any]: 11 }}>
          <img className="eco-chip-logo" src={logoSrc(ecoLibs[11].logo)} alt="" width={16} height={16} />
          <span className="eco-chip-name">{ecoLibs[11].name}</span>
        </li>
        <li className="eco-chip" style={{ ["--i" as any]: 12 }}>
          <img className="eco-chip-logo" src={logoSrc(ecoLibs[12].logo)} alt="" width={16} height={16} />
          <span className="eco-chip-name">{ecoLibs[12].name}</span>
        </li>
        <li className="eco-chip eco-chip--more" style={{ ["--i" as any]: 13 }}>
          <span className="eco-chip-name">…and more</span>
        </li>
      </ul>
      <p className="eco-wall-caption">Utilise the extensive ecosystem.</p>
    </div>
  );
}
